import multiStepForm from './modules/MultiStepForm';
import amrModal from './modules/Modals';
import basketConfig from './config/basket';
import User from './entity/User';
import MiniCartContainer from './components/MiniCartContainer';
import InPostComponent from './components/InPostComponent';
import PosComponent from './components/PosComponent';
import DeliveryMatrix from './components/DeliveryMatrix';
import CountryComponent from './components/CountryComponent';
import FormElement  from './components/FormElement';
import Step1Validator from './validators/Step1Validator';
import Step2Validator from './validators/Step2Validaor';
import Step3Validator from './validators/Step3Validator';
import LoginComponent from './components/LoginComponent';
import RequestFactory from './Request/PlaceOrderFactory';
import ClientAddressComponent from "./components/ClientAddressComponent";
import {CASH_ON_DELIVERY_UPS, CASH_ON_DELIVERY_INPOST, DELIVERY_INPOST, DELIVERY_POS, DELIVERY_PACZKOMAT, DELIVERY_UPS} from "./config/martix";
import CountryComponentStep2 from "./components/CountryComponentStep2";
import DiscountComponent from "./components/DiscountComponent";

const config = basketConfig;

let shippingMethod = $('.shipping-methods .custom-control-input');
let paymentMethod = $('.payment-methods .custom-control-input');

const inpostContainer = new InPostComponent($('#inpostModal'));

const posComponent = new PosComponent($('#basketorder-pos-pos_id'));
const discountComponent = new DiscountComponent($('#basketorder-discount-discountCode'));

const validationInputs = $('#billing-details').find('select, textarea, input, checkbox');

const matrix = new DeliveryMatrix();

const step2Validator = new Step2Validator(validationInputs);

const step2Coutry = new CountryComponentStep2($('#basketorder-customer-kraj-step2'));
step2Coutry.setActiveCountry('PL','Polska');

const countryComponent = new CountryComponent(
    $('#basketorder-customer-kraj'),
    matrix,
    shippingMethod,
    paymentMethod,
    step2Coutry,
    step2Validator
);

var user = new User();
let consents = $('#fieldset-consents input[type="checkbox"]');

function fetchCurrentUser() {
    $.ajax({
        type : 'GET',
        url : '/main/user/profile',
        success : response => userDataFetch(response)
    });
};

function userDataFetch(response) {
    Object.assign(user,response);

    $('#basketorder-customer-imie').val(user.fullname);
    $('#basketorder-customer-adres').val(user.address.street);
    $('#basketorder-customer-kod_pocztowy').val(user.address.postalCode);
    $('#basketorder-customer-miejscowosc').val(user.address.city);
    $('#basketorder-customer-telefon').val(user.contact.phone);
    $('#basketorder-customer-email').val(user.contact.email);


    $('#topbar-user-button')
        .removeClass()
        .addClass('hidden-xs amr-navbar-account small-user-icon-menu')
        .html(`<a href="/account/profile"><span title="${user.contact.email}">${user.contact.email}</span></a>`);

    $('#basketorder-create_account-1')
        .parent()
        .parent()
        .hide();
}

new LoginComponent($('#inner-register-content'), (response) => userDataFetch(response), (response) => {
    alert(response.message);
});

var step1Validator = new Step1Validator(
    shippingMethod,
    paymentMethod,
    inpostContainer,
    posComponent,
    discountComponent,
    matrix
);

var mainForm = new multiStepForm(document.querySelector('.cart-form'), [
        step1Validator,
        step2Validator,
        new Step3Validator(consents, inpostContainer, discountComponent)
    ],() => {
        if (!step1Validator.isFormSubmitted()) {
            step1Validator.setFormSubmitted(true);
        } else {
            return ;
        }
        let factory = new RequestFactory();

        validationInputs.each(function() {

            let name = String($(this).prop('name'));

            if(name === undefined) return;
            if(name === null) return ;
            if(name === '') return ;

            let result = [...name.match(/[a-z\_]+/gi)];

            if($(this).prop('type') === 'checkbox') {
                factory.addField([...$(this).prop('name').match(/[a-z\_]+/gi)], $(this).prop('checked') ? $(this).val() : null);
            } else {
                factory.addField(result,$(this).val());
            }
        });

        $('#fieldset-consents').find('input').each(function () {
            factory.addField([...$(this).prop('name').match(/[a-z\_]+/gi)], $(this).prop('checked') ? $(this).val() : null);
        });

        factory.addByJqueryObject($('.shipping').find('input:checked'));
        factory.addByJqueryObject($('.payment').find('input:checked'));
        
        factory.addPosdata(posComponent.getPos());

        if(factory.request.basketorder.invoice.f_adres !== undefined) {

            let name1 = $('#basketorder-invoice-f_adres').val();
            let name2 = $('#basketorder-invoice-f_adres2').val();

            if(name1.length > 0 && name2.length > 0)
                factory.request.basketorder.invoice.f_adres = $('#basketorder-invoice-f_adres').val() + ' ' + $('#basketorder-invoice-f_adres2').val();
        }

        if(step1Validator.isInpostPointSelected()) {
            factory.addInpostData(inpostContainer.getSelectedPoint(), {
                chk_inpost_accept : 1,
                iemail : $('#basketorder-customer-email').val(),
                itelefon : $('#basketorder-customer-telefon').val()
            });
        }

        if(step1Validator.isDiscountCodeEnteredAndValid()) {
            factory.addDiscount({
                discoundCode : $('#basketorder-discount-discountCode').val(),
                discoundId : $('#basketorder-discount-discountId').val(),
            })
        }

        $('#waiting-container').removeClass('hidden');
        $.ajax({
            type : 'POST',
            url : '/cart/step2',
            data: factory.request,
        }).done((response) => onOrderPlaced(response)).fail(response => {
            step1Validator.setFormSubmitted(false);
            $('#waiting-container').hide();
        })
    },
    (index) => {
        let addressContainer = new ClientAddressComponent();

        if(step1Validator.methodPicked() === DELIVERY_PACZKOMAT || step1Validator.methodPicked() === DELIVERY_POS) {
            addressContainer.hideFields();
            step2Validator.disableAddressValidation();
        }
        else {
            addressContainer.showFields();
            step2Validator.enableAddressValidation();

            let code = $('#basketorder-customer-kraj').val();
            let name = $('#basketorder-customer-kraj').find('option:selected').text();

            step2Coutry.setActiveCountry(code, name);
        }
    }
);

mainForm.onTabChange(function (index) {
    if(index == 1) {
        window.dataLayer.push({
            "event":"EEcheckout",
            "ecommerce": {
                "checkout_option": {
                    "actionField": {"step":1,"option":"Sposób dostępu" }
                },
                "checkout": {
                    "actionField": {"step":2,"option":"Metoda płatności" }
                }
            }
        });

    } else if(index == 2) {
        window.dataLayer.push({
            "event":"EEcheckout",
            "ecommerce": {
                "checkout_option": {
                    "actionField": {"step":2,"option":"Metoda płatności" }
                },

                "checkout": {
                    "actionField": {"step":3,"option":"Podsumowanie zakupu" }
                }
            }
        });
    }
})

function onOrderPlaced(response) {
    if (response.uid === undefined){
        return;
    }
    $.ajax({
        type : 'POST',
        url : `/order/analytics/uid/${response.uid}`
    }).then((analyticsResponse) => {


        $('#waiting-container').show();

        if(analyticsResponse._links) {

            if(analyticsResponse._links.paymentPlacement.href !== null) {
                window.location = analyticsResponse._links.paymentPlacement.href;
            }
            else  {
                window.location = analyticsResponse._links.orderView.href;
            }

        }
    })
}

var modal = new amrModal('.amr-modal');

$('#basketorder-settle_invoice-1').change(function(){
    var checked = $(this).prop('checked');
    $('#fieldset-invoice').prop('disabled', !checked);

    if (!checked) {
        $('#fieldset-invoice').addClass('hidden-sm hidden-xs');
    } else {
        $('#fieldset-invoice').removeClass('hidden-sm hidden-xs');
    }

    window.gtag('event','set_checkout_option', {
        checkout_step : 1,
        checkout_option : 'set invoice data',
        value : checked
    });
});

const checkAllConsents = $('#checkAll');

consents.change(function(){
    if ($(this).prop('checked') === false && checkAllConsents.prop('checked') === true) {
        checkAllConsents.prop('checked', false);
    }
});

checkAllConsents.change(function(){
    if ($(this).prop('checked')) {
       consents.prop('checked', true);
    }
});

const miniContainer = new MiniCartContainer('mini-cart-list');

let selectedPaymentMethod = null;

paymentMethod.on('change', function () {
    selectedPaymentMethod = $(this).val();
})

let basketTotalValue = $('.summary-cart-item .amount').data('price');

shippingMethod.on('change', function () {
    matrix.setDelivery($(this).val());

    let payments = matrix.getAvailablePaymentMethods();
    if (payments !== undefined) {
        paymentMethod.each(function(index, payment) {
            if (payments.indexOf(parseInt(payment.value)) !== -1) {
                $(this).parent().parent().removeClass('hidden');
            }
            else {
                $(this).parent().parent().addClass('hidden');
            }
        });
    }
});

fetchCurrentUser();

function deleteItemRequest(id, onSuccess, onFailure) {
    $.ajax({
        'url' : '/basket/entry',
        'type' : 'post',
        data : {
            id : id
        },
        success: response => onSuccess(response),
        error : response => onFailure(response)
    });
}

validationInputs.on('change', function () {
    let result =  step2Validator.validateField($(this).serializeArray());

    let field = new FormElement($(this));
    field.onValidationResult(result);
});

$('#basketorder-settle_invoice-1').change(function () {

    if($(this).prop('checked')) {
        step2Validator.validateInvoice();
    } else {
        step2Validator.dontValidateInvoice();
    }

    validationInputs.on('change', function () {

        let result =  step2Validator.validateField($(this).serializeArray());

        let field = new FormElement($(this));
        field.onValidationResult(result);
    });
});
